/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

  export class MeevoClientListSelector implements angular.IDirective {
    restrict = "E";
    templateUrl = "app/components/controls/clientListSelector/clientListSelector.template.html";
    require = [
        "meevoClientListSelector",
        "ngModel"
    ];
    scope = {
        securityAccess: "=?",
        disabled: '=?ngDisabled',
        defaultValue: "=?",
        equalClient: '=?',
        minClient: '=?',
        maxClient:'=?',
        clientInfo: '=?',
        showGlobal: '=?',
        isAllClientsVisible: '=?',
        allClients: '=?',
        hideSelectedClientAmount:'=?'
    };
    bindToController = true;
    controller = Meevo.Components.Controls.ClientListSelectorController;
    controllerAs = '$ctrl';
    link = (scope: any, element: JQuery, attr: angular.IAttributes, [ctrl, ngModel]) => {
        ctrl.ngModel = ngModel;
        ctrl.showGlobal = ctrl.hasOwnProperty('showGlobal') ? ctrl.showGlobal : true
        if (scope.clientInfo)
            ctrl.clientInformation = scope.clientInfo; 
        ctrl.init();
    };

    static factory(): angular.IDirectiveFactory {
      let directive = () => {
          return new MeevoClientListSelector();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
      .directive("meevoClientListSelector", MeevoClientListSelector.factory());
}